import { SxProps } from "@mui/system";

export const ModalBottom = () => (
  <svg
    width="169"
    height="79"
    viewBox="0 0 169 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 79.3076H169L0 0.000350952V79.3076Z"
      fill="#A7C7EA"
      fill-opacity="0.36"
    />
    <path
      d="M0.000411987 79.3076H116.129L0.000411987 0.000350952V79.3076Z"
      fill="#EAF1FA"
    />
  </svg>
);
export const ModalTop = () => (
  <svg
    width="169"
    height="79"
    viewBox="0 0 169 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M169 -0.65332H0L169 78.6539V-0.65332Z"
      fill="#A7C7EA"
      fill-opacity="0.36"
    />
    <path d="M169 -0.65332H52.8711L169 78.6539V-0.65332Z" fill="#EAF1FA" />
  </svg>
);


export const CrossIcon = ()=> (
 
  <svg
 
  
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_413_8038)">
      <path
        d="M11.9997 10.5857L16.9497 5.63574L18.3637 7.04974L13.4137 11.9997L18.3637 16.9497L16.9497 18.3637L11.9997 13.4137L7.04974 18.3637L5.63574 16.9497L10.5857 11.9997L5.63574 7.04974L7.04974 5.63574L11.9997 10.5857Z"
        fill="#97999B"
      />
    </g>
    <defs>
      <clipPath id="clip0_413_8038">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

);
export const DeleteIcon = () => (
  <svg
    width="74"
    height="74"
    viewBox="0 0 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="37" cy="37" r="37" fill="#F20F00" fill-opacity="0.08" />
    <g clip-path="url(#clip0_1942_27535)">
      <path
        d="M44.7434 28.8785H51.5116V31.5858H48.8043V49.1834C48.8043 49.5424 48.6617 49.8867 48.4079 50.1406C48.154 50.3944 47.8097 50.537 47.4507 50.537H28.4995C28.1404 50.537 27.7961 50.3944 27.5423 50.1406C27.2884 49.8867 27.1458 49.5424 27.1458 49.1834V31.5858H24.4385V28.8785H31.2068V24.8175C31.2068 24.4585 31.3494 24.1142 31.6032 23.8603C31.8571 23.6065 32.2014 23.4639 32.5604 23.4639H43.3897C43.7487 23.4639 44.093 23.6065 44.3469 23.8603C44.6007 24.1142 44.7434 24.4585 44.7434 24.8175V28.8785ZM46.097 31.5858H29.8531V47.8297H46.097V31.5858ZM33.9141 35.6468H36.6214V43.7687H33.9141V35.6468ZM39.3287 35.6468H42.036V43.7687H39.3287V35.6468ZM33.9141 26.1712V28.8785H42.036V26.1712H33.9141Z"
        fill="#F20F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_1942_27535">
        <rect
          width="32.4878"
          height="32.4878"
          fill="white"
          transform="translate(21.731 20.7559)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ActiveInactiveIcon = () => (
  <svg
    width="74"
    height="74"
    viewBox="0 0 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="37" cy="37" r="37" fill="#F44336" fill-opacity="0.08" />
    <g clip-path="url(#clip0_1942_27595)">
      <path
        d="M45.9729 32.9949V27.9979C45.9729 24.6879 41.3909 21.0029 36.9759 21.0029C32.5609 21.0029 27.9719 24.6889 27.9719 27.9979V32.9949C27.9719 35.1789 28.9689 39.5959 31.7649 41.8409L22.9819 45.9859C22.9819 45.9859 20.9839 46.8759 20.9839 47.9849V50.9859C20.9839 52.0909 21.8789 52.9849 22.9819 52.9849H41.9799V50.9849L22.9829 50.9859V48.9569C22.9829 48.1619 23.5799 47.9119 23.8179 47.8029L32.5999 43.6579C33.2299 43.3689 33.6639 42.7719 33.7489 42.0849C33.8339 41.3979 33.5559 40.7159 33.0159 40.2819C30.9379 38.6139 29.9699 34.9479 29.9699 32.9949V27.9979C29.9699 25.9079 33.6079 23.0029 36.9739 23.0029C40.3699 23.0029 43.9709 25.8639 43.9709 27.9979V32.9949C43.9709 34.9189 43.1709 38.5989 41.0259 40.2869C40.4779 40.7169 40.1939 41.4009 40.2769 42.0929C40.3579 42.7849 40.7939 43.3839 41.4279 43.6749L41.9939 43.9359L42.8709 42.3169L42.2619 41.8569C45.0319 39.6779 45.9699 35.3949 45.9699 32.9949H45.9729ZM49.8949 48.4629L52.7229 45.6339C53.1129 45.2439 53.1129 44.6109 52.7229 44.2199C52.3329 43.8289 51.6989 43.8299 51.3089 44.2199L48.4799 47.0489L45.6519 44.2199C45.2619 43.8299 44.6279 43.8299 44.2379 44.2199C43.8479 44.6099 43.8479 45.2439 44.2379 45.6339L47.0659 48.4619L44.2379 51.2899C43.8479 51.6799 43.8479 52.3139 44.2379 52.7049C44.6279 53.0939 45.2619 53.0939 45.6519 52.7049L48.4799 49.8769L51.3079 52.7049C51.6979 53.0939 52.3319 53.0939 52.7219 52.7049C53.1129 52.3149 53.1129 51.6809 52.7219 51.2899L49.8949 48.4629Z"
        fill="#F20F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_1942_27595">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(21 21)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const ActiveClientIcon = () => (
<svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="37" cy="37" r="37" fill="#3DC826" fill-opacity="0.1"/>
<g clip-path="url(#clip0_2892_4869)">
<path d="M45.9729 32.9949V27.9979C45.9729 24.6879 41.3909 21.0029 36.9759 21.0029C32.5609 21.0029 27.9719 24.6889 27.9719 27.9979V32.9949C27.9719 35.1789 28.9689 39.5959 31.7649 41.8409L22.9819 45.9859C22.9819 45.9859 20.9839 46.8759 20.9839 47.9849V50.9859C20.9839 52.0909 21.8789 52.9849 22.9819 52.9849H41.9799V50.9849L22.9829 50.9859V48.9569C22.9829 48.1619 23.5799 47.9119 23.8179 47.8029L32.5999 43.6579C33.2299 43.3689 33.6639 42.7719 33.7489 42.0849C33.8339 41.3979 33.5559 40.7159 33.0159 40.2819C30.9379 38.6139 29.9699 34.9479 29.9699 32.9949V27.9979C29.9699 25.9079 33.6079 23.0029 36.9739 23.0029C40.3699 23.0029 43.9709 25.8639 43.9709 27.9979V32.9949C43.9709 34.9189 43.1709 38.5989 41.0259 40.2869C40.4779 40.7169 40.1939 41.4009 40.2769 42.0929C40.3579 42.7849 40.7939 43.3839 41.4279 43.6749L41.9939 43.9359L42.8709 42.3169L42.2619 41.8569C45.0319 39.6779 45.9699 35.3949 45.9699 32.9949H45.9729Z" fill="#3DC826"/>
<g clip-path="url(#clip1_2892_4869)">
<path d="M43.6665 48.115L49.7945 41.9863L50.7378 42.929L43.6665 50.0003L39.4238 45.7577L40.3665 44.815L43.6665 48.115Z" fill="#3DC826"/>
</g>
</g>
<defs>
<clipPath id="clip0_2892_4869">
<rect width="32" height="32" fill="white" transform="translate(21 21)"/>
</clipPath>
<clipPath id="clip1_2892_4869">
<rect width="16" height="16" fill="white" transform="translate(37 38)"/>
</clipPath>
</defs>
</svg>
);
export const LogOutIcon = () => (
  <svg
    width="74"
    height="74"
    viewBox="0 0 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="37" cy="37" r="37" fill="#E11D48" fill-opacity="0.08" />
    <path
      d="M48.8667 36.467C48.7333 36.3337 48.7333 36.2003 48.6 36.067L44.6 32.067C44.0667 31.5337 43.2667 31.5337 42.7333 32.067C42.2 32.6003 42.2 33.4003 42.7333 33.9337L44.4667 35.667H38.3333C37.5333 35.667 37 36.2003 37 37.0003C37 37.8003 37.5333 38.3337 38.3333 38.3337H44.4667L42.7333 40.067C42.2 40.6003 42.2 41.4003 42.7333 41.9337C43 42.2003 43.4 42.3337 43.6667 42.3337C43.9333 42.3337 44.3333 42.2003 44.6 41.9337L48.6 37.9337C48.7333 37.8003 48.8667 37.667 48.8667 37.5337C49 37.1337 49 36.867 48.8667 36.467Z"
      fill="#E11D48"
    />
    <path
      d="M41.6667 45.1333C40.2 45.9333 38.6 46.3333 37 46.3333C31.8 46.3333 27.6667 42.2 27.6667 37C27.6667 31.8 31.8 27.6667 37 27.6667C38.6 27.6667 40.2 28.0667 41.6667 28.8667C42.3333 29.2667 43.1333 29 43.5333 28.3333C43.9333 27.6667 43.6667 26.8667 43 26.4667C41.1333 25.5333 39.1333 25 37 25C30.3333 25 25 30.3333 25 37C25 43.6667 30.3333 49 37 49C39.1333 49 41.1333 48.4667 43 47.4C43.6667 47 43.8 46.2 43.5333 45.5333C43.1333 45 42.3333 44.7333 41.6667 45.1333Z"
      fill="#E11D48"
    />
  </svg>
);
export const EmailIconDetail = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1509 6.15039C22.1509 5.05039 21.2509 4.15039 20.1509 4.15039H4.15088C3.05088 4.15039 2.15088 5.05039 2.15088 6.15039V18.1504C2.15088 19.2504 3.05088 20.1504 4.15088 20.1504H20.1509C21.2509 20.1504 22.1509 19.2504 22.1509 18.1504V6.15039ZM20.1509 6.15039L12.1509 11.1504L4.15088 6.15039H20.1509ZM20.1509 18.1504H4.15088V8.15039L12.1509 13.1504L20.1509 8.15039V18.1504Z"
      fill="#010407"
    />
  </svg>
);
export const PhoneIconDetail = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2013_9551)">
      <path
        d="M15.0635 4.08594C16.3356 4.42735 17.4956 5.09736 18.4269 6.02873C19.3583 6.9601 20.0283 8.12005 20.3697 9.39219"
        stroke="#010407"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.2852 6.98242C15.0503 7.18562 15.7481 7.58747 16.3078 8.14724C16.8676 8.70701 17.2695 9.40481 17.4727 10.1699"
        stroke="#010407"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.7915 12.0357C9.56327 13.6295 10.852 14.9149 12.4478 15.6826C12.5655 15.7383 12.6957 15.7625 12.8255 15.7526C12.9554 15.7427 13.0804 15.6992 13.1884 15.6263L15.5321 14.0607C15.6357 13.9905 15.7553 13.9476 15.8799 13.9362C16.0045 13.9247 16.13 13.945 16.2446 13.9951L20.6321 15.8795C20.7821 15.9419 20.9074 16.0519 20.9887 16.1925C21.07 16.3331 21.1028 16.4965 21.0821 16.6576C20.9431 17.743 20.4133 18.7405 19.5919 19.4635C18.7706 20.1865 17.7139 20.5855 16.6196 20.5857C13.2381 20.5857 9.99511 19.2424 7.60402 16.8513C5.21293 14.4602 3.86963 11.2172 3.86963 7.83572C3.86988 6.74147 4.26883 5.6848 4.99184 4.86343C5.71485 4.04207 6.71237 3.51229 7.79775 3.37322C7.95885 3.35253 8.12229 3.38537 8.26289 3.46668C8.40349 3.54799 8.51347 3.67327 8.57588 3.82322L10.4603 8.2201C10.5093 8.33292 10.5298 8.45607 10.5199 8.57869C10.5101 8.7013 10.4703 8.81962 10.404 8.92322L8.83838 11.3045C8.76868 11.4122 8.72777 11.536 8.71956 11.664C8.71135 11.792 8.73612 11.92 8.7915 12.0357Z"
        stroke="#010407"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2013_9551">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.119629 0.335938)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const LocationIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6445 24.6869L6.28054 18.3229C5.02187 17.0642 4.16472 15.4606 3.81746 13.7148C3.4702 11.9689 3.64844 10.1593 4.32963 8.51481C5.01082 6.87028 6.16437 5.46468 7.64441 4.47575C9.12445 3.48682 10.8645 2.95898 12.6445 2.95898C14.4246 2.95898 16.1646 3.48682 17.6447 4.47575C19.1247 5.46468 20.2782 6.87028 20.9594 8.51481C21.6406 10.1593 21.8189 11.9689 21.4716 13.7148C21.1244 15.4606 20.2672 17.0642 19.0085 18.3229L12.6445 24.6869ZM17.5945 16.9089C18.5734 15.9299 19.24 14.6826 19.5101 13.3248C19.7801 11.9669 19.6415 10.5595 19.1116 9.28046C18.5818 8.00142 17.6846 6.90821 16.5335 6.13907C15.3823 5.36994 14.029 4.95941 12.6445 4.95941C11.2601 4.95941 9.90675 5.36994 8.75562 6.13907C7.60449 6.90821 6.70728 8.00142 6.17745 9.28046C5.64761 10.5595 5.50895 11.9669 5.77899 13.3248C6.04902 14.6826 6.71564 15.9299 7.69454 16.9089L12.6445 21.8589L17.5945 16.9089ZM12.6445 13.9589C12.1141 13.9589 11.6054 13.7482 11.2303 13.3731C10.8552 12.998 10.6445 12.4893 10.6445 11.9589C10.6445 11.4285 10.8552 10.9198 11.2303 10.5447C11.6054 10.1696 12.1141 9.95891 12.6445 9.95891C13.175 9.95891 13.6837 10.1696 14.0587 10.5447C14.4338 10.9198 14.6445 11.4285 14.6445 11.9589C14.6445 12.4893 14.4338 12.998 14.0587 13.3731C13.6837 13.7482 13.175 13.9589 12.6445 13.9589Z"
      fill="#010407"
    />
  </svg>
);
